import Util from '@/helper/Utility.js';

export function PaymentModel() {
    this.tranId = null;
    this.cardId = null;
    this.ticketId = null;
    this.useSavedCard = false;
    this.savingCard = false;

    /**
     * Get parameter for api.
     */
    this.getParams = () => {
        var params = {
            tranId: this.tranId,
            cardId: this.cardId,
            ticketId: this.ticketId,
            useSavedCard: this.useSavedCard,
            savingCard: this.savingCard,
        }

        return Util.cleanObjectEmptyStr(params);
    };
}
export function PaymentChannelModel(data){
    this.id = data.Id ?? null;
    this.imageUrl = data.ImageUrl ?? null;
    this.name = data.Name ?? null;
    this.nameEN = data.NameEN ?? null;
    this.sequence = data.Sequence ?? null;
}
